import Cookies from 'js-cookie';

import { getCookieDomain } from '../utils';
import { checkStoreId } from './store';

const SET = 'formlabs/i18n/SET';

const initialState = {
  language: null,
  region: null,
  currency: null,
  timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
  detectedLocale: null
};

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET:
      return { ...state, ...action.payload };
    default:
      return state;
  }
}

const updateLocaleCookie = (language, region, currency) => {
  Cookies.set(
    'locale',
    { region, language, currency },
    { domain: getCookieDomain() }
  );
};

const updateTimezoneCookie = timezone => {
  Cookies.set('timezone', timezone, { domain: getCookieDomain() });
};

export const setLanguage = language => {
  return {
    type: SET,
    payload: {
      language
    }
  };
};

export const setRegion = region => {
  return {
    type: SET,
    payload: {
      region
    }
  };
};

export const setLocale = (language, region, currency, timezone) => {
  return {
    type: SET,
    payload: {
      language,
      region,
      currency,
      timezone
    }
  };
};

export const updateLocale = (language, region, currency, timezone) => {
  updateLocaleCookie(language, region, currency);
  updateTimezoneCookie(timezone);
  return setLocale(language, region, currency, timezone);
};

export const updateLocaleAsync = (language, region, currency) => {
  updateLocaleCookie(language, region, currency);

  return async dispatch => {
    await dispatch(setLocale(language, region, currency));
  };
};

export const checkLocale = (language, region, currency) => {
  const cookieValues = Cookies.getJSON('locale') || {};
  const timezoneCookie = Cookies.get('timezone') || null;
  const userTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return async (dispatch, getState) => {
    if (
      !cookieValues.language ||
      !cookieValues.region ||
      !cookieValues.currency ||
      !timezoneCookie
    ) {
      await dispatch(
        updateLocale(
          cookieValues.language || language,
          cookieValues.region || region,
          cookieValues.currency || currency,
          userTimezone
        )
      );
    } else {
      await dispatch(
        setLocale(
          cookieValues.language,
          cookieValues.region,
          cookieValues.currency,
          userTimezone
        )
      );
    }

    if (timezoneCookie !== userTimezone) {
      updateTimezoneCookie(userTimezone);
    }

    return await dispatch(checkStoreId(language, region));
  };
};
